import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';




let httpHeaders = new HttpHeaders()
.set( 'Authorization', 'Bearer ' + localStorage.getItem('token'))
.set('Content-Type', 'application/json');   
let options = {
headers: httpHeaders
};  

const httpOptions = {
  headers: new HttpHeaders({
    'Authorization': 'Bearer ' + localStorage.getItem('token')
  })
}

@Injectable({
  providedIn: 'root'
})
export class MigrationServiceService {
  private baseUrl = environment.apiUrl + 'UserTemplates/';
  
  constructor(private http: HttpClient) { }

  MigrateUsers(model:any): Observable<any> {
    return this.http.post(this.baseUrl + 'SetUserFromTemplate',model, httpOptions);
  }
 
}
